import e from "../../node_modules/@babel/runtime/helpers/esm/extends.js";
import { __rest as t, __awaiter as r, __generator as o, __assign as i } from "../../node_modules/tslib/tslib.es6.js";
import n, { useRef as s, useEffect as a } from "react";
import { getImageProps as l } from "./getImageProps.js";
import { useImageLoader as c, hasNativeLazyLoadSupport as d } from "./helpers.js";
import { Picture as u } from "./Picture.js";
import { Placeholder as m } from "./Placeholder.js";
import { Wrapper as f } from "./Wrapper.js";
var h = function h(_h) {
  var p,
    v,
    b = _h.fit,
    g = void 0 === b ? "cover" : b,
    y = _h.fixed,
    j = _h.focus,
    w = _h.fluid,
    L = _h.height,
    x = _h.onLoad,
    E = _h.showPlaceholder,
    P = void 0 === E || E,
    I = _h.smart,
    k = _h.width;
  _h.ref;
  var S = t(_h, ["fit", "fixed", "focus", "fluid", "height", "onLoad", "showPlaceholder", "smart", "width", "ref"]),
    O = n.useState(!1 === S.lazy),
    _ = O[0],
    z = O[1],
    C = c(x),
    F = C.onLoad,
    R = C.isLoaded,
    T = C.setLoaded,
    W = n.useRef(),
    Z = s();
  if (a(function () {
    var e;
    if (!(null === (e = W.current) || void 0 === e ? void 0 : e.complete) || !W.current.src) return _ ? void 0 : d() ? void z(!0) : (W.current && r(void 0, void 0, void 0, function () {
      var e;
      return o(this, function (t) {
        switch (t.label) {
          case 0:
            return e = Z, [4, import("./createIntersectionObserver.js")];
          case 1:
            return [4, t.sent().createIntersectionObserver(W.current, function () {
              z(!0);
            })];
          case 2:
            return e.current = t.sent(), [2];
        }
      });
    }), function () {
      Z.current && Z.current.disconnect();
    });
    T();
  }, []), 2 !== (null === (v = null === (p = S.src) || void 0 === p ? void 0 : p.split("/f/")) || void 0 === v ? void 0 : v.length)) return console.error("[storyblok-toolkit]: Image needs a Storyblok image as src"), null;
  var q = l(S.src, {
      fixed: y,
      fluid: w,
      focus: j,
      smart: I
    }),
    A = {
      position: "absolute",
      top: "0px",
      left: "0px",
      width: "100%",
      height: "100%",
      objectFit: g,
      objectPosition: "center center"
    },
    B = i(i(i({}, S), q), {
      style: A
    });
  return n.createElement(f, {
    style: {
      height: L,
      width: k
    }
  }, n.createElement("div", {
    "aria-hidden": !0,
    style: {
      paddingTop: q.height / q.width * 100 + "%"
    }
  }), P && n.createElement(m, {
    src: S.src,
    shouldShow: !R
  }), n.createElement(u, e({}, B, {
    style: i(i({}, A), {
      transform: "translateZ(0)",
      transition: "opacity 250ms linear",
      willChange: "opacity",
      opacity: R ? 1 : 0
    }),
    shouldLoad: _,
    onLoad: F,
    ref: W
  })), n.createElement("noscript", null, n.createElement(u, e({}, B, {
    style: i(i({}, A), {
      opacity: 1
    }),
    shouldLoad: !0
  }))));
};
export { h as Image };